import SubHeader from "./fragments/SubHeader";
import 'bootstrap/dist/css/bootstrap.min.css';
import PurchaseCartList from "./fragments/PurchaseCartList";
import {useDispatch, useSelector} from "react-redux";
import {searchPo, selectPo} from "../../redux/slices/purchassingOrder";
import {getPurchasesCart, selectPurchCart} from "../../redux/slices/purchaseCart";
import {useMemo, useState} from "react";
import {FILTER_INITIAL_STATE} from "./constants";
import InfinityScroll from "../../shared/components/InfinityScroll";
import LoadMoreSpinner from './../../shared/components/LoadMoreSpinner';
import { STATUS_PENDING } from './../../constants';

let isInitialized = false;

export default function CartView() {
    const [filter, setFilter] = useState(FILTER_INITIAL_STATE)

    const {list, noResult, status } = useSelector(selectPurchCart);

    const dispatch = useDispatch();
    
    const nbPos = useMemo(() => {
        return !list ? 0 : list.length;
    }, [list])

    if (!isInitialized) {
        isInitialized = true;
        dispatch(getPurchasesCart({}));
    }

    const handleFilterChange = (filter) => {
        dispatch(getPurchasesCart({filter: filter}))
        setFilter(filter)
    }

    const handleLoadMore = () => dispatch(getPurchasesCart({filter: filter}))

    return (
        <main> 
            <div style={{height: 20}}/>
           {list && 
           <InfinityScroll data={list} hasMore={!noResult} loadMoreAction={handleLoadMore}>
                <PurchaseCartList items={list}/>
            </InfinityScroll>}

            {
                status === STATUS_PENDING &&
                <LoadMoreSpinner number={12} />
            }

        </main>
    )
}
